import { render, staticRenderFns } from "./formCreateDriver.vue?vue&type=template&id=5fd9ea5e&scoped=true"
import script from "./formCreateDriver.vue?vue&type=script&lang=js"
export * from "./formCreateDriver.vue?vue&type=script&lang=js"
import style0 from "./formCreateDriver.vue?vue&type=style&index=0&id=5fd9ea5e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd9ea5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fd9ea5e')) {
      api.createRecord('5fd9ea5e', component.options)
    } else {
      api.reload('5fd9ea5e', component.options)
    }
    module.hot.accept("./formCreateDriver.vue?vue&type=template&id=5fd9ea5e&scoped=true", function () {
      api.rerender('5fd9ea5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/driver/components/form/formCreateDriver.vue"
export default component.exports